import OptionToggle from '../OptionToggle';

interface FilterCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
}

/**
 * Option compacte des panneaux de filtre.
 *
 * Conserve son API historique (`checked` / `onChange`) pour ne pas toucher aux
 * appelants, mais délègue le rendu à `OptionToggle` en variante dense : même
 * mécanique de sélection par surbrillance que partout ailleurs.
 */
export default function FilterCheckbox({ checked, onChange, label }: FilterCheckboxProps) {
  return (
    <OptionToggle variant="row" selected={checked} onToggle={() => onChange(!checked)}>
      {label}
    </OptionToggle>
  );
}
